export enum articlesRecruiterDetailTypes {
  FETCH_ARTICLES_RECRUITER_DETAIL_REQUEST = "FETCH_ARTICLES_RECRUITER_DETAIL_REQUEST",
  FETCH_ARTICLES_RECRUITER_DETAIL_SUCCESS = "FETCH_ARTICLES_RECRUITER_DETAIL_SUCCESS",
  FETCH_ARTICLES_RECRUITER_DETAIL_FAILURE = "FETCH_ARTICLES_RECRUITER_DETAIL_FAILURE",
}